import { CameraGroup } from '@hakimo-ui/hakimo/types';
import { CameraGroupIcon } from '@hakimo-ui/hakimo/ui-elements';
import clsx from 'clsx';
import { useState } from 'react';

interface Props {
  group: CameraGroup;
  selected?: boolean;
  onClick?: () => void;
}

function CameraGroupItem({ group, selected, onClick }: Props) {
  const [showCountInfo, setShowCountInfo] = useState(false);

  return (
    <button
      onClick={onClick}
      className={clsx(
        'relative flex w-full items-center gap-4 rounded-xl p-3 outline-none',
        selected
          ? 'bg-onlight-bg-3 dark:bg-ondark-bg-3'
          : 'hover:bg-onlight-bg-3/50 dark:hover:bg-ondark-bg-3/50'
      )}
    >
      <CameraGroupIcon className="text-onlight-text-2 dark:text-ondark-text-2 h-5 w-5" />

      <div className="min-w-0 flex-1 text-left">
        <div className="dark:text-dark-text text-onlight-text-1 truncate text-sm font-medium">
          {group.name}
        </div>

        <div className="flex items-end justify-between gap-2 leading-tight">
          <span className="dark:text-dark-secondary-text text-onlight-text-3 truncate text-xs">
            {group.locationName}
          </span>

          <div className="relative">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setShowCountInfo((v) => !v);
              }}
              className="dark:text-dark-secondary-text text-onlight-text-3 cursor-pointer text-xs font-medium"
            >
              {group.cameraCount}
            </span>

            {showCountInfo && (
              <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 dark:border-dark-border-surface absolute -right-2 bottom-full whitespace-nowrap rounded-md border px-3 py-1.5 text-xs shadow-xl dark:text-white">
                {group.cameraCount} cameras
              </div>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}

export default CameraGroupItem;
